/* Client-side form-backing object */

'use strict';

var WidgetUtils = {
    importStylesheet: function(libraryPath, absolutePath, media) {

        var url = (absolutePath ? libraryPath : 'styles/' + libraryPath);

        try {
            var link = document.createElement('link');
            link.setAttribute('type', 'text/css');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('href', url);
            link.setAttribute('media', media ? media : 'all');
            var head = document.head ? document.head : document.getElementsByTagName('head')[0];
            head.appendChild(link);
        } catch (ex) {
            console.error(ex);
        }
    },

    stylesheets: [],
    requireStylesheet: function(stylesheetPackage, path, media) {
        var useAbsolute = true;
        if(path == null){
            var packageItems = stylesheetPackage.split('.');
            if(packageItems.length === 1 && packageItems[0] !== 'MITS'){ // Check for external library
                packageItems[0] = packageItems[0].toLowerCase();
                packageItems[1] = packageItems[0].toLowerCase();
                path = packageItems[0].toLowerCase() + '/' + packageItems[0].toLowerCase() + '.css';
            } else {
                packageItems.splice(0, 1);
                path = packageItems.join('/') + '.css';
            }
            useAbsolute = false;
        }

        if (WidgetUtils.stylesheets[path] == null) {
            WidgetUtils.importStylesheet(path, useAbsolute, media);
            WidgetUtils.stylesheets[path] = true;
        }
    }
};

module.exports = WidgetUtils;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/WidgetUtils.js
// module id = 0
// module chunks = 0